/**
 * Parse Supabase rate limit errors and extract wait time
 * @param error - Error from Supabase auth
 * @returns Object with isRateLimit flag and seconds to wait
 */
export function parseRateLimitError(error: unknown): {
  isRateLimit: boolean;
  seconds?: number;
  translationKey?: string;
} {
  if (!error) {
    return { isRateLimit: false };
  }

  const errorMessage = error instanceof Error ? error.message : String(error);

  // Check for sign-up/sign-in rate limit: "For security purposes, you can only request this after X seconds"
  const signUpMatch = errorMessage.match(
    /you can only request this after (\d+) seconds?/i,
  );
  if (signUpMatch && signUpMatch[1]) {
    return {
      isRateLimit: true,
      seconds: parseInt(signUpMatch[1], 10),
      translationKey: 'rate_limit',
    };
  }

  // Check for email rate limit: "email rate limit exceeded"
  if (errorMessage.toLowerCase().includes('email rate limit exceeded')) {
    return {
      isRateLimit: true,
      translationKey: 'email_rate_limit_exceeded',
    };
  }

  // Check for generic rate limit errors
  if (
    errorMessage.toLowerCase().includes('rate limit') ||
    errorMessage.toLowerCase().includes('too many requests')
  ) {
    return {
      isRateLimit: true,
      translationKey: 'rate_limit',
    };
  }

  return { isRateLimit: false };
}
